import React, { Fragment, useEffect } from "react";
import { useState } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { useDispatch, useSelector } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import mikeSvg from "../../assets/images/campaign.svg";
import closeSvg from "../../assets/images/uncheck.svg";
import Select from 'react-select'
import config from "../../config";
import {roles, alphabets, BrandsTypes} from "../../utils/constants";
import CryptoJS from "crypto-js";
import { SlTabGroup, SlTab } from "@shoelace-style/shoelace/dist/react";
import { Toast } from "../../shared/Toast";


function MyPerfomance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  dispatch(SetComponentId(33));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const [currentyearPerfomance, setcurrentyearPerfomance] = useState([]);
  const [previousyearPerfomance, setpreviousyearPerfomance] = useState([]);

  const [selectedList, setSelectedList] = useState(localStorage.getItem("selectedSalesList") && salesUsersList?.length > 1 &&
    JSON.parse(localStorage.getItem("selectedSalesList")).length
    ? salesUsersList.filter((item) =>
        JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
          item.value
        )
      )
    : salesUsersList?.length > 1 ? [] : []);
  const [salesPerson_id, setSalesPerson_id] = useState(
    salesUsersList?.length > 1 ? localStorage.getItem("selectedSalesList") &&
      JSON.parse(localStorage.getItem("selectedSalesList")).length
      ? salesUsersList.filter((item) =>
          JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
            item.value
          )
        )[0]?.value || -1
      : salesUsersList[0]?.value
    : -1);

  const [loader, setLoader] = useState(false);
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;


  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
        salesUsersList.map((item) =>{
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )]);
  const [searchFilter, setSearchFilter] = useState('')
const [showUsersFilter, setShowUsersFilter] = useState( false
    // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
  )
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)
  const fetchPerfomace = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/effort_analysis/getMyPerfomance",
        method: "POST",
        responseType: "json",
        data: {
          date:getYearTimeStamp(),
          sales_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
        },
      });
      if (res.code === 200) {
        setcurrentyearPerfomance(res.data?.currentYear)
        setpreviousyearPerfomance(res.data?.previousYear)
      }
    } catch (error) {
      console.error(error)
      if (error.response.status === 401) navigate("/");
    } finally {
      setLoader(false);
    }
  };
  const onSlSalesChange = (selected) => {
    setSelectedList(
      selected || []
    );
    localStorage.setItem("selectedSalesList", JSON.stringify(selected.map(item => item.value)))
    // if(salesPerson_id !== -1){
      setSalesPerson_id( salesUsersList?.length > 1
        ? selected[selected.length - 1]?.value || -1
        : -1)
        document
        .getElementById(`${selected[selected.length - 1]?.value}`)
        .scrollIntoView({ behavior: "smooth" });
    // } 
  };
  const getYearTimeStamp = () =>{
    const currentDate = new Date();

    // Extract the year from the current date
    const currentYear = currentDate.getFullYear();
    
    // Create a new date object representing the first day of the year
    const firstDayOfYear = new Date(currentYear, 0, 1, 0, 0, 0, 0);
    
    // Get the timestamp in milliseconds
    const firstTimestampOfYear = firstDayOfYear.getTime();
    return Math.round(firstTimestampOfYear / 1000)
  }

  function formatAmount(amount) {
    amount = parseFloat(amount)
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr";
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(2) + " L";
    } else {
      if(!amount) {
        amount = 0
      }
      return amount?.toFixed(2);
    }
  }
  function calculatePercentage(target, reached) {
    if(isNaN(target) || isNaN(reached)) {
      return 0;
    }
    if (parseInt(target) === 0 || parseInt(reached) === 0) {
      return 0;
    }
    const percentage = (reached / target) * 100;
    const percentageInteger = parseInt(percentage.toFixed(2).replace(".", ""));
    const formattedPercentage =
      percentageInteger % 100 === 0
        ? (percentageInteger / 100).toString()
        : percentage.toFixed(2);
    return formattedPercentage;
  }
  const salesTabChange = async (sales_id) => {
    setcurrentyearPerfomance([]);
    setpreviousyearPerfomance([]);
    setSalesPerson_id(sales_id)
  };
  useEffect(() => {
    fetchPerfomace();
  }, [salesPerson_id]);

  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const handleRemove = (event) => {
    const sales_person_id = event;
    let tempArray = selectedList.filter(item => item.value !== +sales_person_id)
    setSelectedList(tempArray)
    let slideToId = salesPerson_id
    if(+sales_person_id === salesPerson_id){
      setSalesPerson_id(tempArray[0].value)
      slideToId = tempArray[0].value
    }
    localStorage.setItem("selectedSalesList", JSON.stringify(tempArray.map(item => item.value)))
    document?.getElementById(slideToId)?.scrollIntoView({ behavior: "smooth" });
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
      try {
        if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
        else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
      } catch (error) {
        console.error("Error @ closeUsersFilter", error)
      }
    }

  return (
    <div>
      <div className="d-flex justify-between flex-wrap my-4">
        <h4>My Performance</h4>
        {/* {salesUsersList?.length ? <div>
        <Select type="text"
          className="!w-96"
          name="sales_person_id"
          placeholder="Sales Person"
          value={selectedList}
          onChange={(selected) => {onSlSalesChange(selected)}}
          options={[ ...salesUsersList]}
          isMulti
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // or any other high value to ensure it is above other elements
            }),
            menuList: (provided) => ({
              ...provided,
              zIndex: 9999, // apply z-index to menuList if needed
            }),
          }}

        />
        </div> : null} */}
        {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
        </div> : null}
      </div>
      <SlTabGroup>
        {!(
          salesUsersList?.length > 1
        ) && (
            <SlTab
              onClick={() => {
                salesTabChange(-1);
              }}
              slot="nav"
              panel="general"
              active={salesPerson_id === -1}
            >
              {localStorage.getItem("name")}
            </SlTab>
          )}
        {selectedList.map((item) => {
          return (
            <SlTab
              slot="nav"
              closable={selectedList.length > 1}
              onSlClose={() => handleRemove(item.value)}
              panel={item.value}
              onClick={() => {
                salesTabChange(item.value);
              }}
              active={salesPerson_id === item.value}
              id={`${item.value}`}
            >
              {item.label}
            </SlTab>
          );
        })}
      </SlTabGroup>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-[#F3F3F3]">
              <th rowSpan={2}>Month</th>
              <th colSpan={2}>Total Target</th>
              <th colSpan={2}>Target achieved</th>
              <th colSpan={2}>Target Achieved %</th>
              <th colSpan={2}>AOV</th>
              <th colSpan={2}>Campaigns</th>
              <th colSpan={2}>Missing</th>
              <th colSpan={2}>Known</th>
              <th colSpan={2}>Unknown</th>
              <th colSpan={2}>Interactions</th>
            </tr>
            <tr className="bg-[#F3F3F3]">
              {Array.from({ length: 9 }, (_, index) => (
                <Fragment key={index}>
                  <th>{currentYear}</th>
                  <th>{previousYear}</th>
                </Fragment>
              ))}
            </tr>

          </thead>
          {currentyearPerfomance?.length && !loader ? (
            <tbody>
              {currentyearPerfomance.map((item, index) => (
                <tr key={item?.month}>
                  <td>{item?.month}</td>
                  <td className="font-semibold">&#8377; {formatAmount(item.total_target)}</td>
                  <td>&#8377;{formatAmount(previousyearPerfomance[index]?.total_target)}</td>
                  <td className="text-[#8524B3]">
                    &#8377; {formatAmount(item.spent)}
                  </td>
                  <td className="text-[#8524B3]">
                    &#8377; {formatAmount(previousyearPerfomance[index]?.spent)}
                  </td>
                  <td>
                    <span
                      className={`${
                        parseInt(calculatePercentage(item.total_target, item.spent)) >= 50
                          ? "greenSpend px-2 py-1"
                          : "redSpend px-2 py-1"
                      }`}
                    >
                      {calculatePercentage(item.total_target, item.spent)}
                      {"%"}
                    </span>
                    {calculatePercentage(item.total_target, item.spent) === "100" ? (
                      <span className="text-[#2DB27A]">
                        <sl-icon name="star-fill"></sl-icon>
                      </span>
                    ) : null}
                  </td>
                  <td>
                    <span
                      className={`${
                        parseInt(calculatePercentage(previousyearPerfomance[index]?.total_target, previousyearPerfomance[index]?.spent)) >= 50
                          ? "greenSpend px-2 py-1"
                          : "redSpend px-2 py-1"
                      }`}
                    >
                      {calculatePercentage(previousyearPerfomance[index]?.total_target, previousyearPerfomance[index]?.spent)}
                      {"%"}
                    </span>
                    {calculatePercentage(previousyearPerfomance[index]?.total_target, previousyearPerfomance[index]?.spent) === "100" ? (
                      <span className="text-[#2DB27A]">
                        <sl-icon name="star-fill"></sl-icon>
                      </span>
                    ) : null}
                  </td>
                  <td>{formatAmount((parseFloat(item.order_value) || 0) / (parseInt(item.order_count) || 1))}</td>
                  <td>{formatAmount((parseFloat(previousyearPerfomance[index]?.order_value) || 0) / (parseInt(previousyearPerfomance[index]?.order_count) || 1))}</td>

                  <td>
                    <div className="d-flex gap-2">
                      <img src={mikeSvg} className="w-4 h-4" alt="mike"></img>{" "}
                      <span className="text-[#8524B3]">{item.w2n_count}</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <img src={mikeSvg} className="w-4 h-4" alt="mike"></img>{" "}
                      <span className="text-[#8524B3]">{previousyearPerfomance[index]?.w2n_count}</span>
                    </div>
                  </td>
                  <td>{Math.max(parseInt(item?.missed || 0), 0)}</td>
                  <td>{Math.max(parseInt(previousyearPerfomance[index]?.missed || 0), 0)}</td>
                  <td>{item.known}</td>
                  <td>{previousyearPerfomance[index]?.known}</td>
                  <td>{item.unknown}</td>
                  <td>{previousyearPerfomance[index]?.unknown}</td>
                  <td>
                    <div className="d-flex gap-2 items-center">
                      <span>Soft: <span className={`${(item.soft || 0) <= 5 ? 'text-red-600' : (item.hard || 0) <= 10 ? 'text-black' : 'text-green-600'} font-semibold`}>{item.soft || 0}</span></span>
                      <span className="h-3 w-0.5 bg-gray-300"></span>
                      <span>Hard: <span className={`${(item.hard || 0) <= 5 ? 'text-red-600' : (item.hard || 0) <= 10 ? 'text-black' : 'text-green-600'} font-semibold`}>{item.hard ||0 }</span></span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-2 items-center">
                      <span>Soft: <span className={`${(previousyearPerfomance[index]?.soft || 0) <= 5 ? 'text-red-600' : (previousyearPerfomance[index]?.hard || 0) <= 10 ? 'text-black' : 'text-green-600'} font-semibold`}>{previousyearPerfomance[index]?.soft || 0}</span></span>
                      <span className="h-3 w-0.5 bg-gray-300"></span>
                      <span>Hard: <span className={`${(previousyearPerfomance[index]?.hard || 0) <= 5 ? 'text-red-600' : (previousyearPerfomance[index]?.hard || 0) <= 10 ? 'text-black' : 'text-green-600'} font-semibold`}>{previousyearPerfomance[index]?.hard ||0 }</span></span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : !currentyearPerfomance?.length && !loader ? (
            <NoDataFound colspan="19" />
          ) : (
            <TableLoader colspan="19" />
          )}
        </table>
      </ScrollContainer>
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    </div>
  );
}

export default MyPerfomance;
